import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import Cookies from "js-cookie";
import { useParams } from "react-router";
import {
  showFullPageLoader,
  hideFullPageLoader,
} from "@/shared/lib/full-page-loader";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { publicRoutes } from "@/shared/services/api/rest/routes";

interface AuthContextProps {
  isAuthenticated: boolean;
  person_id?: number;
  project_id?: number;
  org_id?: number;
  account_id?: number;
}

interface AuthProviderProps {
  children?: React.ReactNode;
}

const PublicAuthContext = createContext({} as AuthContextProps);

function PublicAuthProvider(props: AuthProviderProps) {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<any>(null);

  const { children } = props;
  const { t } = useTranslation();

  const { secret } = useParams<{ secret: string }>();

  const isAuthenticated =
    !!Cookies.get("_s") && !!Cookies.get("authorized_person");

  const authorizePublicUser = useCallback(async () => {
    showFullPageLoader(t("auth.authorizing_access"));
    const response = await axios.post(
      publicRoutes.authorizePublicUser,
      { secret },
      { withCredentials: true }
    );
    setData(response.data);
    setIsLoading(false);
    hideFullPageLoader();
  }, [secret, t]);

  useEffect(() => {
    if (secret) {
      authorizePublicUser();
    }
  }, [secret]);
  const contextValue = {
    isAuthenticated,
    ...data,
  };

  return (
    <PublicAuthContext.Provider value={contextValue}>
      {!isLoading && children}
    </PublicAuthContext.Provider>
  );
}

export const usePublicAuth = () => useContext(PublicAuthContext);

export default PublicAuthProvider;
